export default [
    // 学科查询
    {
        path: "info/jcxxcx/subject-list",
        name: "SubjectList",
        component: ()=> import('./jcxxcx/SubjectList.vue')
    },
    // 学习形式查询
    {
        path: "info/jcxxcx/study-type-list",
        name: "StudyTypeList",
        component: ()=> import('./jcxxcx/StudyTypeList.vue')
    },
    {
        path: "info/jcxxcx/study-type-list",
        name: "StudyTypeList",
        component: ()=> import('./jcxxcx/StudyTypeList.vue')
    },
    // 专业信息列表
    {
        path: "info/zyjhgl/zyxx/specialty-list",
        name: "SpecialtyList",
        component: ()=> import('./zyjhgl/zyxx/SpecialtyList.vue')
    },
    // 专业信息列表-新增
    {
        path: "info/zyjhgl/zyxx/specialty-add",
        name: "SpecialtyAdd",
        component: ()=> import('./zyjhgl/zyxx/SpecialtyAdd.vue')
    },
    // 专业信息列表-修改
    {
        path: "info/zyjhgl/zyxx/specialty-edit",
        name: "SpecialtyEdit",
        component: ()=> import('./zyjhgl/zyxx/SpecialtyEdit.vue')
    },
    // 专业信息列表-专业方向维护
    {
        path: "info/zyjhgl/zyxx/specialty-mintain-list",
        name: "SpecialtyMaintainList",
        component: ()=> import('./zyjhgl/zyxx/SpecialtyMaintainList.vue')
    },
    // 专业信息列表-选修组维护
    {
        path: "info/zyjhgl/zyxx/specialty-elective-list",
        name: "SpecialtyElectiveList",
        component: ()=> import('./zyjhgl/zyxx/SpecialtyElectiveList.vue')
    },

    // 专业课程列表
    {
        path: "info/zyjhgl/zykc/specialty-course-list",
        name: "SpecialtyCourseList",
        component: ()=> import('./zyjhgl/zykc/SpecialtyCourseList.vue')
    },
    // 专业课程列表-课程方向
    {
        path: "info/zyjhgl/zykc/kcfx/specialty-course-direction-list",
        name: "SpecialtyCourseDirectionList",
        component: ()=> import('./zyjhgl/zykc/kcfx/SpecialtyCourseDirectionList.vue')
    },
    // 专业课程列表-课程选修组
    {
        path: "info/zyjhgl/zykc/kcfx/specialty-course-elective-list",
        name: "SpecialtyCourseElectiveList",
        component: ()=> import('./zyjhgl/zykc/kcxxz/SpecialtyCourseElectiveList.vue')
    },
    // 专业课程列表-课程分类维护
    {
        path: "info/zyjhgl/zykc/kcflwh/specialty-course-classify-list",
        name: "SpecialtyCourseClassifyList",
        component: ()=> import('./zyjhgl/zykc/kcflwh/SpecialtyCourseClassifyList.vue')
    },
    // 专业课程列表-课程维护
    {
        path: "info/zyjhgl/zykc/kcwh/specialty-course-classification-list",
        name: "SpecialtyCourseClassificationList",
        component: ()=> import('./zyjhgl/zykc/kcwh/SpecialtyCourseClassificationList.vue')
    },
    // 专业课程列表-课程信息设置
    {
        path: "info/zyjhgl/zykc/kcxxsz/specialty-course-set-list",
        name: "SpecialtyCourseSetList",
        component: ()=> import('./zyjhgl/zykc/kcxxsz/SpecialtyCourseSetList.vue')
    },

    //基础数据职业培训
    {
        path: "info/zypx-course-list",
        name: "ZypxCourseList",
        component: ()=> import('./zypx/ZypxCourseList.vue')
    },
    {
        path: "info/zypx-courselearn-list",
        name: "ZypxCourseLearnList",
        component: ()=> import('./zypx/ZypxCourseLearnList.vue')
    },
	{
        path: "info/zypx-courselearn-add",
        name: "ZypxCourseLearnAdd",
        component: ()=> import('./zypx/ZypxCourseLearnAdd.vue')
    },
	{
        path: "info/zypx-courselearn-edit",
        name: "ZypxCourseLearnEdit",
        component: ()=> import('./zypx/ZypxCourseLearnEdit.vue')
    },
    {
        path: "info/zypx-courselearn-preview",
        name: "ZypxCourseLearnPreview",
        component: ()=> import('./zypx/ZypxCourseLearnPreview.vue')
    },
    {
        path: "info/zypx-courselearn-xxzl",
        name: "ZypxCourseLearnXxzl",
        component: ()=> import('./zypx/ZypxCourseLearnXxzl.vue')
    },
    {
        path: "info/zypx-courselearn-popqus",
        name: "ZypxCourseLearnPopQues",
        component: ()=> import('./zypx/ZypxCourseLearnPopQues.vue')
    },
	{
        path: "info/zypx-lx-list",
        name: "ZypxLxList",
        component: ()=> import('./zypx/ZypxLxList.vue')
    },
    {
        path: "info/skf-config-list",
        name: "SkfConfigList",
        component: ()=> import('./skfpz/SkfConfigList.vue')
    }
];
